import { useEffect, useState } from "react";
import { Routes, Route, NavLink, useNavigate, Navigate } from "react-router-dom";
import { LayoutDashboard, Image, CalendarClock, Globe, Smartphone, Bell, Users, LogOut, Loader2 } from "lucide-react";
import adminApi from "@/services/adminApi";

import DashboardPage from "./DashboardPage";
import BannersPage from "./BannersPage";
import EpgAdminPage from "./EpgAdminPage";
import DomainsPage from "./DomainsPage";
import VersionsPage from "./VersionsPage";
import PushPage from "./PushPage";
import AdminsPage from "./AdminsPage";

const navItems = [
  { path: "/admin/dashboard", icon: LayoutDashboard, label: "Panel" },
  { path: "/admin/banners", icon: Image, label: "Bannerlər" },
  { path: "/admin/epg", icon: CalendarClock, label: "EPG Server" },
  { path: "/admin/domains", icon: Globe, label: "DNS Rotator" },
  { path: "/admin/versions", icon: Smartphone, label: "App Versiya" },
  { path: "/admin/push", icon: Bell, label: "Bildirişlər" },
  { path: "/admin/admins", icon: Users, label: "Adminlər" },
];

export default function AdminLayout() {
  const [admin, setAdmin] = useState(null);
  const [checking, setChecking] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("admin_token");
    if (!token) {
      navigate("/admin");
      return;
    }
    adminApi.me()
      .then(({ data }) => setAdmin(data))
      .catch(() => navigate("/admin"))
      .finally(() => setChecking(false));
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("admin_token");
    navigate("/admin");
  };

  if (checking) {
    return (
      <div className="min-h-screen bg-[#0a0a0c] flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-amber-500 animate-spin" />
      </div>
    );
  }
  if (!admin) return null;

  return (
    <div className="min-h-screen bg-[#0a0a0c] text-white flex">
      {/* Sidebar */}
      <aside className="w-56 flex-shrink-0 bg-black border-r border-zinc-800/60 flex flex-col sticky top-0 h-screen">
        <div className="px-5 py-5 border-b border-zinc-800/60">
          <p className="font-bold text-amber-500">Fibernet TV</p>
          <p className="text-xs text-zinc-500">Admin Panel</p>
        </div>
        <nav className="flex-1 py-3 overflow-y-auto">
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              data-testid={`admin-nav-${item.path.split("/").pop()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-5 py-2.5 text-sm transition-colors ${
                  isActive ? "bg-amber-500/10 text-amber-400 border-r-2 border-amber-500" : "text-zinc-400 hover:text-white hover:bg-white/5"
                }`
              }
            >
              <item.icon className="w-4 h-4" /> {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-zinc-800/60">
          <p className="text-xs text-zinc-500 mb-2 px-1">{admin.username}</p>
          <button
            data-testid="admin-logout-btn"
            onClick={handleLogout}
            className="flex items-center gap-2 text-sm text-zinc-400 hover:text-red-400 transition-colors px-1"
          >
            <LogOut className="w-4 h-4" /> Çıxış
          </button>
        </div>
      </aside>

      {/* Content */}
      <main className="flex-1 min-w-0 p-6 md:p-8 overflow-y-auto">
        <Routes>
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="banners" element={<BannersPage />} />
          <Route path="epg" element={<EpgAdminPage />} />
          <Route path="domains" element={<DomainsPage />} />
          <Route path="versions" element={<VersionsPage />} />
          <Route path="push" element={<PushPage />} />
          <Route path="admins" element={<AdminsPage />} />
        </Routes>
      </main>
    </div>
  );
}
